function mouseStartClickHandler(event, controller) {
  controller.isClickMode += 1;

  controller.lastClickPosition.x = event.clientX;
  controller.lastClickPosition.y = event.clientY;
  controller.lastClickPosition.w = 0;
  controller.lastClickPosition.h = 0;

  if (controller.startClickHandler) controller.startClickHandler(controller.lastClickPosition, event);
}
function mouseClickMoveHandler(event, controller) {
  if (controller.isClickMode < 1) return;

  controller.lastClickPosition.w = Math.max(
      controller.lastClickPosition.w,
      Math.abs(event.clientX - controller.lastClickPosition.x),
  );
  controller.lastClickPosition.h = Math.max(
      controller.lastClickPosition.h,
      Math.abs(event.clientY - controller.lastClickPosition.y),
  );
}
function mouseEndClickHandler(event, controller) {
  if (controller.isClickMode < 1) return;
  controller.isClickMode = Math.max(controller.isClickMode - 1, 0);

  const maxPercent = 0.02;

  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

  if (
    controller.lastClickPosition.w / vw > maxPercent ||
    controller.lastClickPosition.h / vh > maxPercent
  ) return;

  controller.lastClickPosition.x = event.clientX;
  controller.lastClickPosition.y = event.clientY;

  if (controller.endClickHandler) controller.endClickHandler(controller.lastClickPosition, event);
}

function touchStartClickHandler(event, controller) {
  if (event.touches.length > 1) {
    controller.isClickMode = Math.max(controller.isClickMode - 1, 0);
    return;
  }

  controller.isClickMode += 1;

  controller.lastClickPosition.x = event.touches[0].clientX;
  controller.lastClickPosition.y = event.touches[0].clientY;
  controller.lastClickPosition.w = 0;
  controller.lastClickPosition.h = 0;

  if (controller.startClickHandler) controller.startClickHandler(controller.lastClickPosition, event);
}
function touchClickMoveHandler(event, controller) {
  if (controller.isClickMode < 1) return;

  controller.lastClickPosition.w = Math.max(
      controller.lastClickPosition.w,
      Math.abs(event.touches[0].clientX - controller.lastClickPosition.x),
  );
  controller.lastClickPosition.h = Math.max(
      controller.lastClickPosition.h,
      Math.abs(event.touches[0].clientY - controller.lastClickPosition.y),
  );
}
function touchEndClickHandler(event, controller) {
  if (controller.isClickMode < 1) return;
  controller.isClickMode = Math.max(controller.isClickMode - 1, 0);

  const maxPercent = 0.02;

  if (
    controller.lastClickPosition.w / window.innerWidth > maxPercent ||
    controller.lastClickPosition.h / window.innerHeight > maxPercent
  ) return;

  controller.lastClickPosition.x = event.changedTouches[0].clientX;
  controller.lastClickPosition.y = event.changedTouches[0].clientY;

  if (controller.endClickHandler) controller.endClickHandler(controller.lastClickPosition, event);
}


function mouseEnterHandler(event, controller) {
  controller.isHoverMode += 1;

  controller.lastHoverPointerPosition.x = event.clientX;
  controller.lastHoverPointerPosition.y = event.clientY;

  if (controller.enterHandler) controller.enterHandler(controller.lastHoverPointerPosition, event);
}
function mouseHoverMoveHandler(event, controller) {
  if (controller.isHoverMode < 1) return;

  const distanceX = event.clientX - controller.lastHoverPointerPosition.x;
  const distanceY = event.clientY - controller.lastHoverPointerPosition.y;

  controller.lastHoverPointerPosition.x = event.clientX;
  controller.lastHoverPointerPosition.y = event.clientY;

  if (controller.hoverHandler) {
    controller.hoverHandler({dX: distanceX, dY: distanceY, x: event.clientX, y: event.clientY}, event);
  }
}
function mouseLeaveHandler(event, controller) {
  controller.isHoverMode = Math.max(controller.isHoverMode - 1, 0);

  if (controller.leaveHandler) controller.leaveHandler(controller.lastHoverPointerPosition, event);
}


function mouseDownProcessor(event, controller) {
  event.preventDefault();
  // console.log('controller.isDragMode', controller.isDragMode);
  controller.isDragMode += 1;

  controller.lastPointerPosition.x = event.clientX;
  controller.lastPointerPosition.y = event.clientY;

  if (controller.dragStartHandler) controller.dragStartHandler(controller.lastPointerPosition, event);
}
function mouseMoveProcessor(event, controller) {
  if (controller.isDragMode < 1) return;
  event.preventDefault();

  const distanceX = event.clientX - controller.lastPointerPosition.x;
  const distanceY = event.clientY - controller.lastPointerPosition.y;

  controller.lastPointerPosition.x = event.clientX;
  controller.lastPointerPosition.y = event.clientY;

  if (controller.dragHandler) {
    controller.dragHandler({x: distanceX, y: distanceY, pX: event.clientX, pY: event.clientY}, event);
  }
}
function mouseUpProcessor(event, controller) {
  controller.isDragMode = Math.max(controller.isDragMode - 1, 0);

  if (controller.dragEndHandler) controller.dragEndHandler(controller.lastPointerPosition, event);
}

function moveTouchStartProcessor(event, controller) {
  if (event.touches.length > 1) {
    controller.isDragMode = Math.max(controller.isDragMode - 1, 0);
    return;
  }

  event.preventDefault();
  controller.isDragMode += 1;

  controller.lastPointerPosition.x = event.touches[0].clientX;
  controller.lastPointerPosition.y = event.touches[0].clientY;

  if (controller.dragStartHandler) controller.dragStartHandler(controller.lastPointerPosition, event);
}
function moveTouchMoveProcessor(event, controller) {
  if (controller.isDragMode < 1) return;
  event.preventDefault();

  const distanceX = event.touches[0].clientX - controller.lastPointerPosition.x;
  const distanceY = event.touches[0].clientY - controller.lastPointerPosition.y;

  controller.lastPointerPosition.x = event.touches[0].clientX;
  controller.lastPointerPosition.y = event.touches[0].clientY;

  if (controller.dragHandler) {
    const moveDist = controller.dragHandler(
        {x: distanceX, y: distanceY, pX: event.touches[0].clientX, pY: event.touches[0].clientY},
        event,
    );
    if (moveDist != null) {
      const parent = scrollParent(event.target);
      if (moveDist.y != null) parent.scrollTop -= moveDist.y;
      if (moveDist.x != null) parent.scrollLeft -= moveDist.x;
    }
  }
}
function moveTouchEndProcessor(event, controller) {
  controller.isDragMode = Math.max(controller.isDragMode - 1, 0);

  if (controller.dragEndHandler) controller.dragEndHandler(controller.lastPointerPosition, event);
}


function mouseWhellProcessor(event, controller) {
  event.preventDefault();

  const mouseDelta = event.deltaY || event.detail || event.wheelDelta;

  if (controller.zoomHandler({
    pX: event.clientX,
    pY: event.clientY,
    sizeX: Math.sign(mouseDelta),
    sizeY: Math.sign(mouseDelta),
  }, event)) {
    const parent = scrollParent(event.target);
    parent.scrollTop += mouseDelta;
  }
}

function zoomTouchStartProcessor(event, controller) {
  // console.log('tstart', event.touches, event);
  if (event.touches.length != 2) {
    controller.isZoomMode = Math.max(controller.isZoomMode - 1, 0);
    return;
  }

  controller.isZoomMode += 1;

  event.preventDefault();

  controller.lastPointerPosition.fppx = event.touches[0].clientX;
  controller.lastPointerPosition.fppy = event.touches[0].clientY;
  controller.lastPointerPosition.sppx = event.touches[1].clientX;
  controller.lastPointerPosition.sppy = event.touches[1].clientY;

  controller.lastPointerPosition.startMiddleX = (controller.lastPointerPosition.fppx + controller.lastPointerPosition.sppx) * 0.5;
  controller.lastPointerPosition.startMiddleY = (controller.lastPointerPosition.fppy + controller.lastPointerPosition.sppy) * 0.5;
}
function zoomTouchMoveProcessor(event, controller) {
  if (event.touches.length != 2 || controller.isZoomMode < 1) return;

  if (
    Math.abs(controller.lastPointerPosition.fppx - event.touches[0].clientX) < 5 &&
    Math.abs(controller.lastPointerPosition.fppy - event.touches[0].clientY) < 5 &&
    Math.abs(controller.lastPointerPosition.sppx - event.touches[1].clientX) < 5 &&
    Math.abs(controller.lastPointerPosition.sppy - event.touches[1].clientY) < 5
  ) return;

  event.preventDefault();

  const oldSize = Math.sqrt(
      Math.pow(controller.lastPointerPosition.sppx - controller.lastPointerPosition.fppx, 2) +
      Math.pow(controller.lastPointerPosition.sppy - controller.lastPointerPosition.fppy, 2),
  );

  controller.lastPointerPosition.fppx = event.touches[0].clientX;
  controller.lastPointerPosition.fppy = event.touches[0].clientY;
  controller.lastPointerPosition.sppx = event.touches[1].clientX;
  controller.lastPointerPosition.sppy = event.touches[1].clientY;

  const newSize = Math.sqrt(
      Math.pow(controller.lastPointerPosition.sppx - controller.lastPointerPosition.fppx, 2) +
      Math.pow(controller.lastPointerPosition.sppy - controller.lastPointerPosition.fppy, 2),
  );

  const newAngle = Math.max(Math.min(Math.abs(Math.atan(
      (controller.lastPointerPosition.sppy-controller.lastPointerPosition.fppy) /
      (controller.lastPointerPosition.sppx-controller.lastPointerPosition.fppx),
  ) * 2 / Math.PI), 1), 0);

  controller.zoomHandler({
    pX: controller.lastPointerPosition.startMiddleX,
    pY: controller.lastPointerPosition.startMiddleY,
    sizeX: -Math.sign(newSize - oldSize) * (1 - newAngle) * 2,
    sizeY: -Math.sign(newSize - oldSize) * (newAngle) * 2,
  }, event);
}
function zoomTouchEndProcessor(event, controller) {
  controller.isZoomMode = Math.max(controller.isZoomMode - 1, 0);
}


function gestureController(domNode) {
  const curNode = domNode;
  const ans = {
    connectedNode: curNode,
    registerClick: null,
    registerHover: null,
    registerDrag: null,
    registerZoom: null,
    isClickMode: 0,
    isHoverMode: 0,
    isDragMode: 0,
    isZoomMode: 0,
    lastZoomData: {fppx: 0, fppy: 0, sppx: 0, sppy: 0, startMiddleX: 0, startMiddleY: 0},
    lastPointerPosition: {x: 0, y: 0},
    lastHoverPointerPosition: {x: 0, y: 0},
    lastClickPosition: {x: 0, y: 0},
    destruct: null,
  };

  const clickRegistrator = (startClickHandler, endClickHandler) => {
    if (ans.endClickHandler != null) return;

    ans.endClickHandler = endClickHandler;
    ans.startClickHandler = startClickHandler;

    ans.mouseStartClickHandler = (event) => mouseStartClickHandler(event, ans);
    ans.mouseClickMoveHandler = (event) => mouseClickMoveHandler(event, ans);
    ans.mouseEndClickHandler = (event) => mouseEndClickHandler(event, ans);

    curNode.addEventListener('mousedown', ans.mouseStartClickHandler);
    document.addEventListener('mousemove', ans.mouseClickMoveHandler);
    document.addEventListener('mouseup', ans.mouseEndClickHandler);

    ans.touchStartClickHandler = (event) => touchStartClickHandler(event, ans);
    ans.touchClickMoveHandler = (event) => touchClickMoveHandler(event, ans);
    ans.touchEndClickHandler = (event) => touchEndClickHandler(event, ans);

    curNode.addEventListener('touchstart', ans.touchStartClickHandler);
    document.addEventListener('touchmove', ans.touchClickMoveHandler);
    document.addEventListener('touchend', ans.touchEndClickHandler);
  };
  const mouseHoverRegistrator = (enterHandler, moveHandler, leaveHandler) => {
    if (ans.enterHandler != null || ans.hoverHandler != null) return;

    ans.enterHandler = enterHandler;
    ans.hoverHandler = moveHandler;
    ans.leaveHandler = leaveHandler;

    ans.mouseEnterHandler = (event) => mouseEnterHandler(event, ans);
    ans.mouseHoverMoveHandler = (event) => mouseHoverMoveHandler(event, ans);
    ans.mouseLeaveHandler = (event) => mouseLeaveHandler(event, ans);

    curNode.addEventListener('mouseenter', ans.mouseEnterHandler);
    curNode.addEventListener('mousemove', ans.mouseHoverMoveHandler);
    curNode.addEventListener('mouseleave', ans.mouseLeaveHandler);
  };
  const dragRegistrator = (handler, startHandler, endHandler) => {
    if (ans.dragHandler != null) return;

    ans.dragHandler = handler;
    ans.dragStartHandler = startHandler;
    ans.dragEndHandler = endHandler;

    ans.mouseMoveHandler = (event) => mouseMoveProcessor(event, ans);
    ans.mouseDownHandler = (event) => mouseDownProcessor(event, ans);
    ans.mouseUpHandler = (event) => mouseUpProcessor(event, ans);

    curNode.addEventListener('mousedown', ans.mouseDownHandler);
    document.addEventListener('mousemove', ans.mouseMoveHandler);
    document.addEventListener('mouseup', ans.mouseUpHandler);

    ans.moveTouchStartHandler = (event) => moveTouchStartProcessor(event, ans);
    ans.moveTouchMoveHandler = (event) => moveTouchMoveProcessor(event, ans);
    ans.moveTouchEndHandler = (event) => moveTouchEndProcessor(event, ans);

    curNode.addEventListener('touchstart', ans.moveTouchStartHandler);
    document.addEventListener('touchmove', ans.moveTouchMoveHandler);
    document.addEventListener('touchend', ans.moveTouchEndHandler);
  };
  const zoomRegistrator = (handler) => {
    if (ans.zoomHandler != null) return;

    ans.zoomHandler = handler;

    ans.mouseWhellHandler = (event) => mouseWhellProcessor(event, ans);
    curNode.addEventListener('wheel', ans.mouseWhellHandler);

    ans.zoomTouchStartHandler = (event) => zoomTouchStartProcessor(event, ans);
    ans.zoomTouchMoveHandler = (event) => zoomTouchMoveProcessor(event, ans);
    ans.zoomTouchEndHandler = (event) => zoomTouchEndProcessor(event, ans);

    curNode.addEventListener('touchstart', ans.zoomTouchStartHandler);
    document.addEventListener('touchmove', ans.zoomTouchMoveHandler);
    document.addEventListener('touchend', ans.zoomTouchEndHandler);
  };
  const destruct = () => {
    curNode.removeEventListener('mousedown', ans.mouseStartClickHandler);
    document.removeEventListener('mousemove', ans.mouseClickMoveHandler);
    document.removeEventListener('mouseup', ans.mouseEndClickHandler);

    curNode.removeEventListener('touchstart', ans.touchStartClickHandler);
    document.removeEventListener('touchmove', ans.touchClickMoveHandler);
    document.removeEventListener('touchend', ans.touchEndClickHandler);


    curNode.removeEventListener('mouseenter', ans.mouseEnterHandler);
    curNode.removeEventListener('mousemove', ans.mouseHoverMoveHandler);
    curNode.removeEventListener('mouseleave', ans.mouseLeaveHandler);


    curNode.removeEventListener('mousedown', ans.mouseDownHandler);
    document.removeEventListener('mousemove', ans.mouseMoveHandler);
    document.removeEventListener('mouseup', ans.mouseUpHandler);

    curNode.removeEventListener('touchstart', ans.moveTouchStartHandler);
    document.removeEventListener('touchmove', ans.moveTouchMoveHandler);
    document.removeEventListener('touchend', ans.moveTouchEndHandler);


    curNode.removeEventListener('wheel', ans.mouseWhellHandler);

    curNode.removeEventListener('touchstart', ans.zoomTouchStartHandler);
    document.removeEventListener('touchmove', ans.zoomTouchMoveHandler);
    document.removeEventListener('touchend', ans.zoomTouchEndHandler);
  };

  ans.registerClick = clickRegistrator;
  ans.registerHover = mouseHoverRegistrator;
  ans.registerDrag = dragRegistrator;
  ans.registerZoom = zoomRegistrator;
  ans.destruct = destruct;

  return ans;
}

export default gestureController;

/* !
 * jQuery UI Scroll Parent @VERSION
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

// >>label: scrollParent
// >>group: Core
// >>description: Get the closest ancestor element that is scrollable.
// >>docs: https://api.jqueryui.com/scrollParent/
// >>source_code: https://github.com/jquery/jquery-ui/blob/main/ui/scroll-parent.js
function scrollParent(elem, includeHidden=false) {
  const style = getComputedStyle(elem);
  const root = elem.ownerDocument || document;
  if (style.position === 'fixed') return root;
  const excludeStaticParent = style.position === 'absolute';
  const overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
  // eslint-disable-next-line no-var
  for (var parent = elem; (parent = parent.parentElement);) {
    const parStyle = getComputedStyle(parent);
    if (excludeStaticParent && parStyle.position === 'static') continue;
    if (overflowRegex.test(parStyle.overflow + parStyle.overflowY + parStyle.overflowX)) return parent;
  }
  return root;
}
